import { useEffect, useState } from "react";
import { resolveImageRef } from "../utils/resolveImageRef";

const DATA_URL_BLOB_THRESHOLD = 32000;

/**
 * Algunos navegadores fallan con <img src="data:...muy-largo"> (ERR_INVALID_URL).
 * Para data URLs grandes, las convertimos a object URL (blob:).
 */
export const useResolvableImageSrc = (rawValue) => {
  const [src, setSrc] = useState("");

  useEffect(() => {
    let cancelled = false;
    let objectUrl = "";

    const revokeIfNeeded = (url) => {
      if (url && url.startsWith("blob:")) URL.revokeObjectURL(url);
    };

    const normalized = resolveImageRef(rawValue || "");
    if (!normalized) {
      setSrc("");
      return () => {};
    }

    const shouldBlob =
      normalized.startsWith("data:image") &&
      (normalized.length >= DATA_URL_BLOB_THRESHOLD || (rawValue && String(rawValue).length >= DATA_URL_BLOB_THRESHOLD));

    if (!shouldBlob) {
      setSrc(normalized);
      return () => {};
    }

    (async () => {
      try {
        const res = await fetch(normalized);
        const blob = await res.blob();
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setSrc(objectUrl);
      } catch (error) {
        if (!cancelled) setSrc(normalized);
      }
    })();

    return () => {
      cancelled = true;
      revokeIfNeeded(objectUrl);
    };
  }, [rawValue]);

  return src;
};
